import React, { Component } from 'react';
import axios from '../lib/axios';

export default class Links extends Component{
  constructor(props) {
    super(props);
    this.state = { links: [] };
  }

  componentWillMount() {
		axios.get('/links')
		.then(response => this.setState({ links: response.data }))
	}

  render() {
    return (
      <div className="list-links-container custom-horizontal-scrollbar">
        <ul>
        { this.state.links.map(link => (
          <li key={`link-${link.id}`}>
            <a href={link.url} target="_blank">
              <img src={require('../img/icon-external-link.svg')} className="icon-normal" />
              <img src={require('../img/icon-external-link-hover.svg')} className="icon-hover" />
              {link.name}
            </a>
          </li>
        ))}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Links.js